import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { User } from 'models/User';
import { AvatarWithInitials } from 'components/AvatarWithInitials';
import { getUserFullName, normalizeEmail } from 'utils';
import VerifiedWithCopy from './components/VerifiedWithCopy';

import './ContactUserInfo.styles.scss';

type ContactUserInfoProps = {
  className?: string;
  user: User;
  showPhone?: boolean;
  showLinkedIn?: boolean;
  isCurrentUser?: boolean;
};

const ContactUserInfo: React.FC<ContactUserInfoProps> = (props) => {
  const { className, user, isCurrentUser } = props;

  const { firstName, lastName, email, hasVerifiedEmail } = user || {};

  const fullName = getUserFullName(firstName, lastName);

  const normalizedEmail = normalizeEmail(email);

  const classes = classNames('contact-user-info', className);

  const { t } = useTranslation();

  return (
    <VerifiedWithCopy
      className={classes}
      copyValue={normalizedEmail}
      copyText={t('copyEmail')}
      isVerified={hasVerifiedEmail}
      verifiedText={t('emailVerified')}
      notVerifiedText={t('emailNotVerified')}
    >
      <div className="main-info">
        <AvatarWithInitials user={user} />

        <div className="name-email">
          <p className="name-row">
            <span className="name">{fullName}</span>
            {isCurrentUser && <span className="you-tag">{t('you')}</span>}
          </p>
          <p>{normalizedEmail}</p>
        </div>
      </div>
    </VerifiedWithCopy>
  );
};

export default ContactUserInfo;
